var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRupee = function SvgRupee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "rupee_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#rupee_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "evenodd",
    d: "M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19m2.943-10.44.338-1.154h-1.41a3 3 0 0 0-.32-.91 2.4 2.4 0 0 0-.232-.355l1.624.013.338-1.154H8.838L8.5 8.614h1.372l.775.006q.954.05 1.442.516.332.314.462.77H8.838L8.5 11.06h4.086a1.6 1.6 0 0 1-.213.527q-.264.402-.76.606-.498.2-1.204.2H8.6l.02.834 3.64 4.455h1.55v-.08l-3.36-4.116h.03q1.243 0 1.998-.403.76-.402 1.104-1.064.235-.45.312-.96z",
    clipRule: "evenodd"
  }))));
};
export default SvgRupee;